// extracted by mini-css-extract-plugin
export default {"duplicateIssuesDisplay":"DuplicateIssuesSection-module__duplicateIssuesDisplay--louc5"};